import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a5257f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  id: "simulate-click",
  style: {"display":"none"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["message", _ctx.type])
  }, [
    _createElementVNode("p", null, [
      _createTextVNode(_toDisplayString(_ctx.text) + " ", 1),
      (_ctx.text)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "audio-btn",
            href: "#",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.playAudio && _ctx.playAudio(...args)), ["prevent"]))
          }, "🔊"))
        : _createCommentVNode("", true)
    ]),
    (_ctx.translation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("a", {
            href: "#",
            class: "translation-link",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleTranslation && _ctx.toggleTranslation(...args)), ["prevent"]))
          }, _toDisplayString(_ctx.$t('word.seeTranslation')), 1),
          (_ctx.showTranslation)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.translation), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _hoisted_3
  ], 2))
}